/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ResourceTagFromJSON, ResourceTagToJSON, } from './';
export function PlayerUpdateRequestFromJSON(json) {
    return PlayerUpdateRequestFromJSONTyped(json, false);
}
export function PlayerUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ResourceTagFromJSON)),
        'confirmationDate': !exists(json, 'confirmationDate') ? undefined : json['confirmationDate'],
        'confirmedBy': !exists(json, 'confirmedBy') ? undefined : json['confirmedBy'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'resolution': !exists(json, 'resolution') ? undefined : json['resolution'],
        'rotation': !exists(json, 'rotation') ? undefined : json['rotation'],
        'orientation': !exists(json, 'orientation') ? undefined : json['orientation'],
        'publicKey': !exists(json, 'publicKey') ? undefined : json['publicKey'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'active': json['active'],
        'screenPositions': !exists(json, 'screenPositions') ? undefined : json['screenPositions'],
        'impressions': !exists(json, 'impressions') ? undefined : json['impressions']
    };
}
export function PlayerUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(ResourceTagToJSON)),
        'confirmationDate': value.confirmationDate,
        'confirmedBy': value.confirmedBy,
        'format': value.format,
        'resolution': value.resolution,
        'rotation': value.rotation,
        'orientation': value.orientation,
        'publicKey': value.publicKey,
        'locationId': value.locationId,
        'active': value.active,
        'screenPositions': value.screenPositions,
        'impressions': value.impressions
    };
}
